import { CloseOutlined } from '@ant-design/icons';

interface NoResultsScreenProps {
  /** Override the default full-viewport sizing (e.g. flex containers like All Tasks). */
  className?: string;
  message?: string;
}

/** Standard "no results" empty state shared across task modules. */
export default function NoResultsScreen({ className, message = 'No results found.' }: NoResultsScreenProps) {
  return (
    <div
      style={className ? undefined : { height: 'calc(100vh - 130px)', width: 'calc(100vw - 256px)' }}
      className={`flex flex-col items-center justify-center gap-5 ${className ?? ''}`}
    >
      <div className="w-11 h-11 bg-neutral-300 rounded-full flex items-center justify-center">
        <CloseOutlined className="text-neutral-900" />
      </div>
      <div className="text-center text-neutral-900 text-sm font-medium font-['Figtree'] leading-tight">{message}</div>
    </div>
  );
}
